import { Component, Input } from '@angular/core';
import { SharingContext } from '../../../../../models/sharing-context';
import { ModalService } from '../../../../../services/modal.service';
import { PlatformLinkService } from '../../../../../services/platform-link.service';
import {
    PlatformLinkCopiedConfirmationModalComponent
} from '../../../pages/modal-container/platform-link-copied-confirmation-modal/platform-link-copied-confirmation-modal.component';
import { SharingOptionsComponent } from '../../../../utils/sharing-options/sharing-options.component';
import { RealPageNumberPipe } from '../../../../../pipes/real-page-number.pipe';
import { NgClass } from '@angular/common';
import { BookFeatureService } from '../../../../../services/book-feature.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'app-share-dropdown',
    templateUrl: './share-dropdown.component.html',
    styleUrls: ['./share-dropdown.component.scss'],
    standalone: true,
    imports: [
        SharingOptionsComponent,
        RealPageNumberPipe,
        NgClass
    ]
})
export class ShareDropdownComponent {
    @Input() context: SharingContext;
    @Input() position: 'left' | 'right';

    constructor(
        private modalService: ModalService,
        private platformLinkService: PlatformLinkService,
        private bookFeatureService: BookFeatureService,
        private applicationStateService: ApplicationStateService) {
    }

    onPlatformLinkCopied($event: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string
    }): void {
        if ($event) {
            this.platformLinkService.setPlatformLink($event);
            this.modalService.openModal(PlatformLinkCopiedConfirmationModalComponent);
        }
    }

    /**
     * controls whether BookViewer tools are closed when share button is clicked.
     */
    handleClosingTools($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.applicationStateService.pageEditMode?.type === 'DRAW' ||
            this.applicationStateService.pageEditMode?.type === 'SELECTION' ||
            this.applicationStateService.pageEditMode?.type === 'RECT') {
            this.bookFeatureService.dismissMode()
        }
    }
}
